<div class="xr-page xr-qr-page">
  <header class="xr-page-header">
    <div>
      <h1 class="xr-page-title">{{ "qrcode.title" | translate }}</h1>
    </div>
  </header>

  <div class="xr-qr-layout">
    <section class="xr-card xr-qr-card" aria-labelledby="qr-owner">
      @if (qrcode) {
        <img [src]="qrcode" class="xr-qr-image"
             [alt]="'qrcode.qr_alt' | translate: { name: (technician?.name || '') + ' ' + (technician?.lastname || '') }"/>
      } @else if (qrLoaded) {
        <div class="xr-empty xr-qr-empty">{{ "technicians.no_qrcode" | translate }}</div>
      }
      <p id="qr-owner" class="xr-qr-name">{{ technician?.name }} {{ technician?.lastname }}</p>
      @if (qrcode) {
        <div class="xr-qr-actions">
          <button type="button" class="xr-btn xr-btn--secondary" (click)="sendEmail(technician)">
            <i-tabler name="send-2" class="icon-18 d-flex" aria-hidden="true"></i-tabler>
            {{ "qrcode.send_email" | translate }}
          </button>
          <button type="button" class="xr-btn xr-btn--primary" (click)="downloadQrcode()">
            <i-tabler name="download" class="icon-18 d-flex" aria-hidden="true"></i-tabler>
            {{ "qrcode.download" | translate }}
          </button>
        </div>
      }
    </section>

    <section class="xr-card xr-qr-help" aria-labelledby="qr-help-title">
      <h2 id="qr-help-title" class="xr-card-title">{{ "qrcode.how_title" | translate }}</h2>
      <ol>
        <li>{{ "qrcode.step_1" | translate }}</li>
        <li>{{ "qrcode.step_2" | translate }}</li>
        <li>{{ "qrcode.step_3" | translate }}</li>
        <li>{{ "qrcode.step_4" | translate }}</li>
      </ol>
    </section>
  </div>
</div>
